import { useContext, useState } from "react";
// Material ui
import { Box, Button, CircularProgress, Typography } from "@mui/material";

// Firebase
import { addDoc, collection, doc, setDoc } from "firebase/firestore";
import { db } from "../firebase-config";
import {
  getAuth,
  createUserWithEmailAndPassword,
  sendEmailVerification,
  updateProfile,
} from "firebase/auth";
// Components
import SignupForm from "../components/SignupForm";
import logo from "../assets/logo_treso.png";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../contexts/userContext";
import { ISignupExtended } from "../interfaces";
import { BUSINESS_COLLECTION, USERS_COLLECTION } from "../utils/constants";

const Signup = () => {
  const { handleSetUser } = useContext(UserContext);
  const [signupInfo, setSignupInfo] = useState({} as ISignupExtended);
  const [loading, setLoading] = useState(false);
  const userCollectionRef = collection(db, USERS_COLLECTION);
  const businessCollectionRef = collection(db, BUSINESS_COLLECTION);
  const navigate = useNavigate();

  const handleChange = (type: string, value: string) =>
    setSignupInfo({ ...signupInfo, [type]: value });

  const handleCreateUser = async ({
    email,
    password,
  }: {
    email: string;
    password: string;
  }) => {
    const auth = getAuth();
    return createUserWithEmailAndPassword(auth, email, password);
  };

  const handleSubmit = async () => {
    setLoading(true);

    const {
      name,
      business_address,
      business_name,
      business_phone,
      email,
      password,
    } = signupInfo;

    await handleCreateUser({
      email,
      password,
    })
      .then(async (userCredential) => {
        const { uid, emailVerified } = userCredential.user;
        await updateProfile(userCredential.user, {
          displayName: name,
        });
        await sendEmailVerification(userCredential.user);

        const businessItem = {
          name: business_name,
          phone: business_phone,
          address: business_address,
          status: "enabled",
          createdAt: new Date(),
          updatedAt: new Date(),
        };

        await addDoc(businessCollectionRef, businessItem).then(
          async (docRef) => {
            const userRef = doc(userCollectionRef, uid);
            const item = {
              uid,
              email,
              emailVerified,
              name,
              business: docRef.id,
              status: "enabled", // cambiara a disabled cuando se haga la verificacion de email
              role: "ADMIN",
              createdAt: new Date(),
              updatedAt: new Date(),
            };

            await setDoc(userRef, item).then(() => {
              handleSetUser(item.uid);
              navigate("/");
              setSignupInfo({} as ISignupExtended);
            });
          }
        );
      })
      .catch((error) => {
        // TODO agregar alerta de error
        const errorCode = error.code;
        const errorMessage = error.message;
        console.log("ERROR: ", errorCode, errorMessage);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100vh"
      width="100vw"
    >
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        height="fit-content"
        width="fit-content"
        sx={{
          boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
          borderRadius: "10px",
          backgroundColor: "#FFFFFF",
        }}
      >
        <img src={logo} alt="Logo" className="login_logo" />
        <Typography>Treso</Typography>
        {loading ? (
          <Box
            p={4}
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
          >
            <CircularProgress size={120} />
            <Typography mt={10}>
              Estamos creando tu cuenta. Espere por favor
            </Typography>
          </Box>
        ) : (
          <>
            <SignupForm signupInfo={signupInfo} handleChange={handleChange} />
            <Button
              disabled={loading}
              variant="contained"
              onClick={handleSubmit}
              sx={{ mb: 3 }}
              color="secondary"
            >
              Crear cuenta
            </Button>
          </>
        )}
      </Box>
    </Box>
  );
};

export default Signup;
